module.exports = __webpack_public_path__ + "static/img/khademalsharieh.4be89ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/personas/khademalsharieh.jpg
// module id = 484
// module chunks = 11